import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, OceanTag, StatusChip } from "./kit";
import { OCEAN_PHASES } from "../../data/oceanContent";

export default function OceanRoadmap() {
  const [active, setActive] = useState(0);
  const phase = OCEAN_PHASES[active];

  return (
    <section id="roadmap" data-testid="ocean-roadmap-section" className="relative py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <OceanTag index="05" label="Expedition Roadmap" />
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-oseaglass leading-[0.95]">
              Six phases <span className="text-oreef">to the water</span>
            </h2>
            <p className="max-w-md text-sm font-mono text-ogold tracking-wide leading-relaxed lg:text-right">
              NO DEPARTURE DATE IS A CONFIRMED COMMITMENT. STATUS REFLECTS ACTUAL PROJECT PROGRESS.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute left-[18px] top-2 bottom-2 w-px bg-oslate/20" aria-hidden="true" />
              {OCEAN_PHASES.map((p, i) => {
                const on = active === i;
                return (
                  <button
                    key={p.num}
                    onClick={() => setActive(i)}
                    data-testid={`roadmap-phase-${i}`}
                    className="relative flex items-center gap-4 w-full text-left py-3.5 group"
                  >
                    <span className={`relative z-10 w-9 h-9 rounded-full flex items-center justify-center font-mono text-xs border transition-colors duration-300 ${on ? "bg-oreef text-onavy border-oreef" : "bg-onavy text-oslate border-oslate/30 group-hover:border-oreef/50"}`}>
                      {p.num}
                    </span>
                    <span className={`font-display font-semibold text-lg tracking-wide transition-colors duration-300 ${on ? "text-oseaglass" : "text-oslate group-hover:text-oseaglass/80"}`}>
                      {p.title}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-7">
            <AnimatePresence mode="wait">
              <motion.div
                key={active}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                className="border border-oreef/20 bg-oabyss/40 p-8 sm:p-10 h-full"
                data-testid="roadmap-detail"
              >
                <div className="flex items-center justify-between gap-4">
                  <span className="font-display font-extrabold text-6xl sm:text-7xl text-reef-stroke leading-none">{phase.num}</span>
                  <StatusChip status={phase.status} />
                </div>
                <h3 className="font-display font-bold text-2xl sm:text-3xl text-oseaglass mt-4 tracking-wide">{phase.title}</h3>
                <ul className="mt-6 space-y-3">
                  {phase.items.map((it) => (
                    <li key={it} className="text-sm sm:text-base text-oseaglass/75 flex gap-3 leading-relaxed">
                      <span className="text-ocoral shrink-0 mt-1">▸</span>{it}
                    </li>
                  ))}
                </ul>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
